import React, { useState } from "react";
import { Button } from "antd";
import { RocketOutlined, ArrowRightOutlined } from "@ant-design/icons";

const CONTACT_URL = "https://conek.vn";

/**
 * Đáy sidebar: card "Nâng cấp" (Liên hệ conek.vn) + copyright Shinko và dòng ghi công
 * đơn vị phát triển.
 * collapsed -> chỉ hiện nút tròn liên hệ để tiết kiệm bề ngang.
 *
 * Card cố ý CHỈ MỘT DÒNG và không có nút trắng bên trong: đây là lời mời nâng cấp, không
 * phải thao tác nghiệp vụ — để nó nổi hơn cả menu đang chọn là sai thứ tự ưu tiên thị giác
 * (SOUND.md). Cả khối là một link, tiết kiệm ~85px chiều dọc — trục chật nhất trên laptop.
 */
export default function SidebarFooter({ collapsed = false, isDarkMode = false }) {
  const copyrightColor = isDarkMode ? "rgba(255,255,255,0.45)" : "#94A3B8";
  const [hovered, setHovered] = useState(false);

  if (collapsed) {
    return (
      <div style={{ padding: "8px 0", display: "flex", justifyContent: "center", flexShrink: 0 }}>
        <a href={CONTACT_URL} target="_blank" rel="noreferrer" title="Nâng cấp hệ thống — Liên hệ Conek">
          <Button type="primary" shape="circle" icon={<RocketOutlined />} />
        </a>
      </div>
    );
  }

  return (
    <div style={{ padding: 12, flexShrink: 0 }}>
      {/* Card nâng cấp — cả khối là một link */}
      <a
        href={CONTACT_URL}
        target="_blank"
        rel="noreferrer"
        title="Nâng cấp hệ thống — Liên hệ Conek"
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
        style={{
          display: "flex",
          alignItems: "center",
          gap: 8,
          background: "linear-gradient(135deg, #0F2A47 0%, #1D4ED8 100%)",
          borderRadius: 10,
          padding: "10px 12px",
          color: "#fff",
          textDecoration: "none",
          boxShadow: hovered
            ? "0 6px 16px -6px rgba(15,42,71,0.55)"
            : "0 2px 8px -4px rgba(15,42,71,0.45)",
          transform: hovered ? "translateY(-1px)" : "none",
          transition: "transform 0.15s ease, box-shadow 0.15s ease",
        }}
      >
        <RocketOutlined style={{ color: "#93C5FD", fontSize: 15 }} />
        <span style={{ fontWeight: 600, fontSize: 13, flex: 1 }}>Nâng cấp</span>
        <ArrowRightOutlined
          style={{
            fontSize: 12,
            color: "rgba(255,255,255,0.75)",
            transform: hovered ? "translateX(2px)" : "none",
            transition: "transform 0.15s ease",
          }}
        />
      </a>

      {/* Footer thương hiệu: chủ sở hữu là Shinko, Conek là đơn vị phát triển. */}
      <div style={{ marginTop: 14, textAlign: "center", lineHeight: 1.7 }}>
        <div style={{ fontSize: 11, color: copyrightColor }}>© 2026 Shinko Corp</div>
        <div style={{ fontSize: 11, color: copyrightColor }}>
          Phát triển bởi{" "}
          <a
            href={CONTACT_URL}
            target="_blank"
            rel="noreferrer"
            style={{ color: "#93C5FD", fontWeight: 600 }}
          >
            Conek
          </a>
        </div>
      </div>
    </div>
  );
}
